import isEmptyObject from '../../src-i-adapter/helpers/is-empty-object';

/**
 *  returns object containing certificate(s) for brands.
 *
 *  note: Currently only returns the VISA cert
 *
 *  @returns {object}
 *
 *  ex.
 *
 *    {
 *      MA: {
 *        kid: "KID_VALUE",
 *        name: "CERT_ID",
 *        publicKey: {
 *          e: 12345,
 *          n: "MODULUS_VALUE"
 *        }
 *      },
 *      VISA: {
 *        kid: "KID_VALUE",
 *        name: "CERT_ID",
 *        publicKey: {
 *          e: 12345,
 *          n: "MODULUS_VALUE"
 *        }
 *      }
 *    }
 *
 */
export const getCertificates = () => ({
  VISA: window.VISA_GLOBALS?.srcEnvConfig?.cert
});

/**
 *  returns object containing public key for a brand/network
 *
 *  @param {object} certs - object containing certificates of card brands/networks
 *  @param {string} brand - string containing brand/network to return cert for
 *  @returns {object} - object containing certificate values ()
 *
 */
export const getCertificatePublicKey = (certs, brand) => {
  return !isEmptyObject(certs) && certs[brand] ? certs[brand].publicKey : {};
};

/**
 *  returns kid value for a cert
 *
 *  @param {object} certs - object containing certificates of card brands/networks
 *  @param {string} brand - string containing brand/network to return cert for
 *  @returns {string} - kid value
 *
 */
export const getCertificateKid = (certs, brand) =>
  !isEmptyObject(certs) && certs[brand] ? certs[brand].kid : undefined;
